function difference(a, b) {
    const s = new Set(b);
    return a.filter((x) => !s.has(x));
}
export default difference;
//# sourceMappingURL=difference.js.map